import { render, staticRenderFns } from "./OrderRecordDetails.vue?vue&type=template&id=5c227b7f&scoped=true&"
import script from "./OrderRecordDetails.vue?vue&type=script&lang=js&"
export * from "./OrderRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderRecordDetails.vue?vue&type=style&index=0&id=5c227b7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c227b7f",
  null
  
)

export default component.exports